import { render, staticRenderFns } from "./changeTestNumber.vue?vue&type=template&id=0c36422a&scoped=true"
import script from "./changeTestNumber.vue?vue&type=script&lang=js"
export * from "./changeTestNumber.vue?vue&type=script&lang=js"
import style0 from "./changeTestNumber.vue?vue&type=style&index=0&id=0c36422a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36422a",
  null
  
)

export default component.exports